module.exports = __webpack_public_path__ + "static/media/computers1.73f59d2d.png";